var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadFileDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#upload_file_drop_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.667 1.87h-20a3.343 3.343 0 0 0-3.333 3.333v23.333h3.333V5.203h20zM25 8.536H13.334c-1.834 0-3.317 1.5-3.317 3.334L10 35.203c0 1.833 1.483 3.333 3.317 3.333h18.35c1.833 0 3.333-1.5 3.333-3.333V18.536zM13.334 35.203V11.87h10v8.333h8.333v15z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "upload_file_drop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .203h40v40H0z"
})))));
export default SvgUploadFileDrop;